export default __webpack_public_path__ + "static/media/rider-background.90f4756a.png";